import { Logo, Text } from 'shell/components';

const LogoDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>Logo</Text>
            <Logo device={'mobile'} />
            <Logo device={'tablet'} />
            <Logo device={'desktop'} />
            <Logo />
        </>
    );
};

export default LogoDemo;
